import * as React from "react";
import { Tag } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { convertUtcToLocal } from "../../helpers/CommonHelpers";
import ReleaseNotesLink from "../Docs/ReleaseNotesLink";

interface VersionInfoChipProps {
  version?: string;
  label: string;
  lastHealthCheckUtc?: string;
  /** Which build the version names, so it can link to the release that shipped it. */
  component?: "client" | "updater";
}

export const VersionInfoChip: React.FC<VersionInfoChipProps> = ({
  version,
  label,
  lastHealthCheckUtc,
  component,
}: VersionInfoChipProps) => {
  const healthInfo =
    (version
    && lastHealthCheckUtc
    && lastHealthCheckUtc !== "0001-01-01T00:00:00Z")
      ? version + " - " + convertUtcToLocal(lastHealthCheckUtc)
      : "Unknown";

  const isKnown = healthInfo !== "Unknown";

  return (
    <div className="flex items-center gap-1 mb-1">
      <span className="text-xs min-w-[120px] text-[0.75rem]">
        {label}:
      </span>
      <Badge variant={isKnown ? "primary" : "neutral"}>
        {isKnown && <Tag className="size-3" />}
        {healthInfo}
      </Badge>
      {isKnown && component && <ReleaseNotesLink component={component} version={version} compact />}
    </div>
  );
};
